import moment from 'moment'
import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/i2Sales'

export default {
  namespaced: true,
  state: {
    loading: false,
    overviews: {
      sales: 0,
      connections: 0,
      stocks: 0,
      chartData: {
        series: [
          {
            name: null,
            type: 'column',
            data: [],
          },
        ],
        categories: [],
        chartTitle: null,
        yaxis: [
          {
            min: 0,
            seriesName: null,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#008FFB',
            },
            labels: {
              style: {
                colors: '#008FFB',
              },
            },
            title: {
              text: null,
              style: {
                color: '#008FFB',
              },
            },
            tooltip: {
              enabled: true,
            },
          },
        ],
      },
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    overviews(state) {
      return state.overviews
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_OVERVIEWS(state, data) {
      state.overviews = data
    },
    /* RESET MUTATIONS */
    RESET_OVERVIEWS(state) {
      state.overviews = {
        sales: 0,
        connections: 0,
        stocks: 0,
        chartData: {
          series: [
            {
              name: null,
              type: 'column',
              data: [],
            },
          ],
          categories: [],
          chartTitle: null,
          yaxis: [
            {
              min: 0,
              seriesName: null,
              axisTicks: {
                show: true,
              },
              axisBorder: {
                show: true,
                color: '#008FFB',
              },
              labels: {
                style: {
                  colors: '#008FFB',
                },
              },
              title: {
                text: null,
                style: {
                  color: '#008FFB',
                },
              },
              tooltip: {
                enabled: true,
              },
            },
          ],
        },
      }
    },
  },
  actions: {
    getOverviews({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_OVERVIEWS')
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/overviews`, data)
        .then(response => {
          commit('SET_OVERVIEWS', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
  },
}
